module.exports = __webpack_public_path__ + "img/xbox.ef78d12a.png";